import { useState, useEffect } from 'react'
import { client } from '@/services/sanityClient'

export function useSanityQuery(query, params = {}) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    client.fetch(query, params)
      .then(setData)
      .finally(() => setLoading(false))
  }, [query])

  return { data, loading }
}
